module.exports = __webpack_public_path__ + "img/uso_quebra_ventos_1.e8e49278.webp";